import type { Theme } from '@mui/material';

export const getWrapperSx = (theme: Theme, size: number, corner: number) => ({
  width: size,
  height: size,
  position: 'relative',
  borderRadius: `${corner}px`,
  overflow: 'hidden',
  userSelect: 'none',
  backgroundColor: theme.palette.dark,
  boxShadow: 'none',
});

export const innerWrapperSx = {
  position: 'absolute',
  inset: 0,
  pointerEvents: 'none',
};

export const stackSx = {
  position: 'absolute',
  inset: 0,
  alignItems: 'center',
  justifyContent: 'center',
};